export default {
  data() {
    return {
      isMounted: false,
    };
  },

  mounted() {
    this.isMounted = true;
  },

  methods: {
    errorTabClass(tabname, errorSections, form) {
      let theForm;
      if (typeof form === "undefined") {
        theForm = this.form;
      } else {
        theForm = form;
      }

      let sections;
      if (typeof errorSections === "undefined") {
        // Guess by using `this.form`
        sections = theForm.errors.sections();
      } else {
        sections = errorSections;
      }

      return sections.includes(tabname) ? "error" : "";
    },
  },

  computed: {
    currentTabName() {
      if (this.isMounted) {
        const tabs = this.$lodash.get(this.$refs, "tabs");

        if (tabs) {
          return this.$lodash.toLower(tabs.tabs[tabs.currentTab].title);
        }
      }

      return "";
    },
  },
};
